<template>
  <b-card>
    <b-card-header class="bg-info">
      <b-card-title>ایجاد نامه</b-card-title>
    </b-card-header>
    <b-card-body>
      <b-form @submit.prevent>
        <b-row>
          <b-col md="4">
            <b-form-group
              label="عنوان نامه"
            >
              <b-form-input
                v-model="title"
                placeholder="عنوان نامه  را وارد کنید"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              label="متن نامه"
            >
              <div>
                <quill-editor
                  v-model="content"
                  :options="editorOption"
                />
              </div>

            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              :description="`${sms.length}/${maxChar}`"
              label="متن پیامک"
            >
              <div>
                <b-form-textarea
                  id="textarea-state"
                  v-model="sms"
                  :state="sms.length <= 130"
                  placeholder="متن پیامک"
                  rows="3"
                />
              </div>

            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4">
            <b-form-group
              label="درجه اهمیت"
            >
              <b-overlay
                :show="prioritiesList.length === 0"
              >
                <v-select
                  v-model="priority"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="title"
                  :options="prioritiesList"
                  :reduce="priority => priority.id"
                />
              </b-overlay>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-overlay :show="!getReceivers">
              <b-form-group
                label="دریافت کنندگان"
              >
                <v-select
                  v-model="receivers"
                  multiple
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="name"
                  :options="receiversList"
                  :reduce="receiver => receiver.id"
                />
              </b-form-group>
            </b-overlay>

          </b-col>
          <b-col cols="12">
            <b-card>
              <b-card-body>
                <b-row
                  v-for="(item, index) in attachment.items"
                  :id="item.id"
                  :key="item.id"
                >
                  <!-- Item Name -->
                  <b-col md="4">
                    <b-form-group>
                      <label :for="`attachment_${item.id}`">
                        <feather-icon
                          icon="PaperclipIcon"
                        />
                        فایل
                      </label>
                      <b-form-file
                        v-model="item.file"
                        placeholder="فایل را انتخاب کنید یا به اینجا بکشید"
                        drop-placeholder="عکس را به اینحا بکشید"
                        no-drop
                      />
                    </b-form-group>
                  </b-col>

                  <!-- Remove Button -->
                  <b-col
                    lg="2"
                    md="3"
                    class="mb-50"
                  >
                    <b-button
                      variant="outline-danger"
                      class="mt-0 mt-md-2"
                      @click="removeItem(index)"
                    >
                      <feather-icon
                        icon="XIcon"
                        class="mr-25"
                      />
                      <span>حذف فایل</span>
                    </b-button>
                  </b-col>
                  <b-col cols="12">
                    <hr>
                  </b-col>
                </b-row>
                <b-button
                  variant="primary"
                  @click="repeateAgain"
                >
                  <feather-icon
                    icon="PlusIcon"
                    class="mr-25"
                  />
                  <span>افزودن فایل</span>
                </b-button>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
        <b-button
          variant="success"
          :disabled="onProgress"
          @click="createTicket"
        >
          <b-spinner
            v-if="onProgress"
            small
          />
          {{ onProgress ? 'درحال پردازش درخواست...' : 'ثبت نامه ' }}
        </b-button>
      </b-form>
    </b-card-body>
  </b-card>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardBody,
  BForm,
  BFormGroup,
  BFormInput,
  BOverlay,
  BCardTitle,
  BSpinner,
  BButton,
  BFormFile,
  BFormTextarea,
} from 'bootstrap-vue'
import VSelect from 'vue-select'
import { quillEditor } from 'vue-quill-editor'
import { debounce } from '@/libs/debounce'

export default {
  name: 'TicketsCreate',
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BForm,
    BFormGroup,
    BFormInput,
    BOverlay,
    VSelect,
    BCardTitle,
    BSpinner,
    BButton,
    BFormFile,
    quillEditor,
    BFormTextarea,

  },
  data() {
    return {
      title: '',
      getReceivers: false,
      receiversList: [],
      receivers: [],
      onProgress: false,
      content: '',
      editorOption: {
        theme: 'snow',
        placeholder: 'متن پیام را وارد کنید',
      },
      sms: '',
      maxChar: 140,
      priority: '',
      prioritiesList: [],
      attachment: {
        items: [
          {
            id: 1,
            file: null,
          },
        ],
        nextItemId: 2,
      },
    }
  },
  mounted() {
    this.getPriorities()
    this.getRelatedUsers()
  },

  methods: {
    repeateAgain() {
      this.attachment.nextItemId++
      this.attachment.items.push({
        id: this.attachment.nextItemId,
        file: null,
      })
    },
    removeItem(index) {
      this.attachment.items.splice(index, 1)
    },
    getRelatedUsers() {
      this.$http.get('tickets/related-users')
        .then(({ data }) => {
          if (data.status) {
            this.receiversList = data.users
            this.getReceivers = true
          } else {
            this.$bvToast.toast(data.message ?? 'دریافت لیست دریافت کنندگان با خطا مواجه شد', {
              title: 'حطا',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          }
        })
        .catch(error => {
          this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
            title: 'خطا در دریافت اطلاعات',
            toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
            variant: 'danger',
          })
        })
    },
    getPriorities() {
      this.$http.get('tickets/priorities')
        .then(({ data }) => {
          if (data.status) {
            this.prioritiesList = data.priorities
          } else {
            this.$bvToast.toast(data.message ?? 'دریافت لیست اولویت ها با خطا مواجه شد', {
              title: 'حطا',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          }
        })
        .catch(error => {
          this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
            title: 'خطا در دریافت اطلاعات',
            toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
            variant: 'danger',
          })
        })
    },
    async createTicket() {
      if (this.title === '') {
        this.$bvToast.toast('عنوان نامه نمیتواند خالی باشد', {
          title: 'خطا',
          toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
          variant: 'danger',
        })
        return false
      }
      if (this.content == null) {
        this.$bvToast.toast('متن نامه وارد شود', {
          title: 'خطا',
          toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
          variant: 'danger',
        })
        return false
      }

      this.onProgress = true
      this.onSaving = true

      const ticketFormData = new FormData()

      ticketFormData.append('title', this.title)
      ticketFormData.append('content', this.content)
      ticketFormData.append('sms', this.sms)
      ticketFormData.append('priority', this.priority)
      this.receivers.map(receiver => {
        ticketFormData.append('receivers[]', receiver)
      })
      this.attachment.items.map(attachment => {
        ticketFormData.append('attachments[]', attachment.file)
      })

      await this.$http.post('tickets', ticketFormData, {
        header: [
          'Content-Type:multipart/form-data',
        ],
      })
        .then(({ data }) => {
          if (data.status) {
            this.title = ''
            this.content = ''
            this.sms = ''
            this.priority = ''
            this.receivers = []
            this.attachment = {
              items: [
                {
                  id: 1,
                  file: null,
                },
              ],
              nextItemId: 2,
            }

            this.$bvToast.toast('نامه  با موفقیت ثبت شد', {
              title: 'انجام درخواست',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'success',
            })
          } else {
            this.$bvToast.toast(data.message ?? 'ثبت نامه  انجام نشد', {
              title: 'حطا',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          }
        })
        .catch(error => {
          this.$bvToast.toast(error.response.data.message ?? error, {
            title: 'خطا در دریافت اطلاعات',
            toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
            variant: 'danger',
          })
        })
        .finally(() => {
          this.onProgress = false
        })
    },
  },
}
</script>
